module.exports = __webpack_public_path__ + "img/purple_dots.c0e3eb9d.png";